import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { useManualServerSentEvents } from "../../hook/useManualServerSentEvents";
import Router, { useRouter } from "next/router";
import { ShowMessage } from "../ShowMessage/ShowMessage";
import http from "../../http";
import styles from "../../styles/chat.module.scss";
import ChatCreatContent from "./ChatCreatContent";
import ChatTextArea from "./ChatTextArea";
import { useUserInfo } from "../../context/ThemeContext";
import ChatpdfLine from "./ChatpdfLine";
import RepoCodePreview, { selectData } from "../RepoCodePreview";
import { Alert, notification, Splitter } from "antd";
import { useThread } from "../../pages";
import UpLoad, { accept } from "../UpLoad/UpLoad";
import { throttle } from "lodash";
import SettingModal from "../setting/SettingModal";
import BottomLayer from "./BottomLayer";
import { useCommonData } from "../../layout/ELayout";
const ChatpdfBox = (
  props: {
    reLoadCancleChat: (id: string) => void;
    cancleChat: (id: string) => Promise<any>;
    updateMenu: () => void;
    repoClick: (isClose: boolean) => void;
    gotoLogin: () => void;
  },
  ref: any
) => {
  const router = useRouter();
  const { commonData, changeCommonData } = useCommonData();
  const [api, contextHolder] = notification.useNotification();
  const { thread_id, setThread } = useThread();
  const { userInfo, toggleUserInfo } = useUserInfo();
  const markdown = useRef("");
  const uploadFile = useRef<{
    openai_file_id: string;
    original_filename: string;
  }>({
    openai_file_id: "",
    original_filename: "",
  });
  const repository = useRef<{
    url: string;
    type: string;
    repo_full_name?: string;
    branch_name?: string;
  }>({
    url: "",
    type: "",
    repo_full_name: "",
    branch_name: "",
  });
  const chatTextArea = useRef<any>();
  const chatpdfLine = useRef<any>(null);
  const chatPanel = useRef<any>(null);
  const [chatpdfTips, setChatpdfTips] = useState(true);
  const [flag, setFlag] = useState(false);
  const [stop, setStop] = useState(false);
  const [chatContent, setChatContent] = useState([] as any);
  const { getUserInfo } = useUserInfo();
  const [splitterSize, setSplitterSize] = useState<any[]>(["100%", 0]);
  const splitterSizeRef = useRef<any[]>(["100%", 0]);
  const [loading, setLoading] = useState(false);
  const [quoteData, setQuoteData] = useState<selectData>();
  const [showRepoName, setShowRepoName] = useState<{
    type: string;
    repo_full_name: string;
    branch_name: string;
  }>({
    type: "",
    repo_full_name: "",
    branch_name: "",
  });
  const [dragOver, setDragOver] = useState(false);
  const isShowRepo = useRef(false);
  const repoCodePreview = useRef<any>();
  useEffect(() => {
    reSizeChatWidth();
  }, [chatpdfTips]);
  useEffect(() => {
    setTimeout(() => {
      reSizeChatWidth();
    }, 100);
  }, [splitterSize]);
  useEffect(() => {
    splitterSizeRef.current = splitterSize;
  }, [splitterSize]);
  useEffect(() => {
    codePreviewClose();
    setQuoteData(undefined);
  }, [thread_id]);

  useEffect(() => {
    if (flag) {
      api.warning({
        key: "noticePay",
        message: "对话机会已用完",
        placement: "top",
        description: (
          <div>
            您的今日试用对话机会已用完，请明天继续使用，或者
            <SettingModal tabKey="pay">
              <a style={{ textDecoration: "underline" }}>购买会员</a>
            </SettingModal>
          </div>
        ),
        duration: 0,
      });
    } else {
      notification.destroy("noticePay");
    }
  }, [api, flag]);

  useEffect(() => {
    if (
      chatContent.length > 0 &&
      !chatContent[chatContent.length - 1].pending
    ) {
      // 找到data.data最后一个user_type是user的元素
      const lastData = chatContent
        .slice()
        .reverse()
        .find((item: any) => item.user_type === "user");
      if (lastData.file_id) {
        chatTextArea?.current?.initFileData({
          openai_file_id: lastData.file_id,
          original_filename: lastData.metadata?.file_name || "",
        });
      }
      if (lastData.metadata?.repository) {
        chatTextArea?.current?.initRepoData(lastData.metadata.repository);
      }
    }
  }, [chatContent]);

  useImperativeHandle(ref, () => {
    return {
      createNewChat,
      getChatLog,
      createThread,
      reSizeChatWidth,
    };
  });
  window.onresize = () => {
    reSizeChatWidth();
  };
  const reSizeChatWidth = () => {
    const chatPanelDom = chatPanel?.current;
    if (chatPanelDom) {
      const width = chatPanelDom?.clientWidth;
      if (chatpdfLine?.current) {
        chatpdfLine.current?.setChatWidth({
          width: width < 1200 ? `${width - 16}px` : `${1200}px`,
        });
      }
      if (chatTextArea?.current) {
        chatTextArea?.current?.setChatWidth({
          width: width < 1200 ? `${width - 48}px` : `${1152}px`,
        });
      }
    }
  };
  const resetFn = (isChating: boolean = false) => {
    setStop(false);
    if (isChating) {
      setTimeout(() => {
        props.updateMenu();
      }, 1000);
    }
  };
  const clearFileId = () => {
    uploadFile.current = { openai_file_id: "", original_filename: "" };
  };

  const getInfo = () => {
    getUserInfo();
  };
  // 在组件内部定义节流函数
  const goToBottomThrottled = useMemo(
    () =>
      throttle(() => {
        chatpdfLine.current?.goToBottom();
      }, 300), // 300ms 可根据实际情况调整
    []
  );
  const { messages, startFetching, stopFetching, responseState, isoutputing } =
    useManualServerSentEvents("/api/v1/chat/chat", setFlag, getInfo, resetFn);
  useEffect(() => {
    chatContent[chatContent.length - 1] = {
      text: messages.value,
      user_type: "assistant",
      pending: messages.pending,
      thinking_text: messages.reasoning,
      thread_id: thread_id,
      uuid: messages.uuid,
    };
    // 找到chatContent最后一个user_type === "user"的元素
    const lastUserIndex = chatContent.findLastIndex(
      (item: { user_type: string }) => item.user_type === "user"
    );
    if (lastUserIndex !== -1) {
      chatContent[lastUserIndex].uuid = messages.userAskid;
    }
    setChatContent([...chatContent]);
    if (!chatpdfTips && chatpdfLine.current) {
      goToBottomThrottled();
    }
  }, [messages]);

  // 聊天
  const createChat = useCallback(
    (props: {
      chatContent: any[];
      editItem?: any;
      uuid?: string;
      quoteData?: selectData;
    }) => {
      const { chatContent, editItem, uuid, quoteData } = props;
      //点击发送
      if (flag) {
        setText("");
        ShowMessage.error(
          "您的今日试用对话机会已用完，请明天继续使用，或者购买会员"
        );
        return;
      }
      if (markdown.current.trim() == "") {
        ShowMessage.error("请输入您需要解读的内容");
        return;
      }
      let metadata = {
        // code_snippet: !!quoteData?.filename
        //   ? {
        //     file_path: quoteData?.filepath,
        //     file_name: quoteData?.filename,
        //     start_line: quoteData?.startLineNumber,
        //     end_line: quoteData?.endLineNumber,
        //   }
        //   : null,
      };
      repository.current = chatTextArea?.current?.getRepoUrl();
      if (repository.current.url) {
        metadata = { ...metadata, repository: repository.current };
        handleClickRepo(
          {
            type: repository.current.type,
            repo_full_name: repository.current.repo_full_name || "",
            branch_name: repository.current.branch_name || "",
            url: repository.current.url,
          },
          "preview"
        );
      }
      if (uploadFile.current.original_filename && !repository.current.url) {
        handleClickRepo(
          {
            type: "local",
            repo_full_name: uploadFile.current.original_filename,
            branch_name: "master",
          },
          "preview"
        );
      }
      setChatContent([
        ...chatContent,
        {
          text: markdown.current,
          user_type: "user",
          thread_id: thread_id,
          uuid: editItem?.uuid || uuid || "",
          metadata: editItem
            ? editItem.metadata
            : {
                ...metadata,
                file_name: uploadFile.current.original_filename,
              },
        },
        {
          text: "",
          user_type: "assistant",
          thread_id: thread_id,
          pending: true,
        },
      ]);
      startFetching({
        file_id: uploadFile.current.openai_file_id,
        thread_id: thread_id,
        message: markdown.current,
        message_id: editItem?.uuid || "",
        metadata: editItem ? editItem.metadata : metadata,
        thinking_enabled:
          localStorage.getItem("deepThinking") === "true" ? true : false,
      });
      // 记录当前thread_id
      const ids = JSON.parse(localStorage.getItem("threadIds") || "[]");
      localStorage.setItem("threadIds", JSON.stringify([...ids, thread_id]));
      setChatpdfTips(false);
      setStop(true);
      setText("");
      markdown.current = "";
      setTimeout(() => {
        if (!chatpdfTips && chatpdfLine.current) {
          chatpdfLine.current?.goToBottom(true);
        }
      }, 200);
    },
    [chatpdfTips, flag, startFetching, thread_id]
  );

  const handleInputChange = (e: { target: any }) => {
    const textarea = e.target;
    markdown.current = textarea.value;
  };
  useEffect(() => {
    if (responseState === 500) {
      props.reLoadCancleChat(thread_id);
    } else if (responseState === 401) {
      getInfo();
    }
  }, [responseState, thread_id]);
  // 创建对话
  const createThread = () => {
    setLoading(true);
    setStop(false);
    clearFileId();
    http
      .post(`/api/v1/chat/thread`)
      .then((data: any) => {
        if (data.status) {
          if (data.code == 402) {
            setFlag(true);
            getInfo();
            return;
          }
          setFlag(false);
          setThread(data.data.thread_id);
          Router.push(`/?thread_id=${data.data.thread_id}`);
          setThread(data.data.thread_id as string);
          setChatContent([]);
        } else {
          ShowMessage.error(data.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  // 获取聊天历史
  const getChatLog = async (threadId: any) => {
    if (threadId === thread_id) {
      return;
    }
    clearFileId();
    chatTextArea?.current?.clear();
    setLoading(true);
    setThread(threadId);
    Router.push(`/?thread_id=${threadId}`);
    setText("");
    stopFetching();
    resetFn();
    http
      .get(`/api/v1/chat/chat_history?thread_id=${threadId}`)
      .then((data: any) => {
        if (data.status) {
          if (data.data.length == 0) {
            setChatpdfTips(true);
          } else {
            setChatpdfTips(false);
          }
          setChatContent(data.data);
          setTimeout(() => {
            if (!chatpdfTips && chatpdfLine.current) {
              chatpdfLine.current?.goToBottom(true);
              reSizeChatWidth();
            }
          }, 200);
        } else {
          ShowMessage.error(data.message?.output || data.message);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const createNewChat = async (logout: boolean = false) => {
    codePreviewClose();
    setChatpdfTips(true);
    setText("");
    // setMarkdown('')
    markdown.current = "";
    chatTextArea?.current?.clear();
    if (!logout) {
      props.cancleChat(thread_id);
      createThread();
    }
  };
  const cancleFn = () => {
    //取消发送
    if (chatContent[chatContent.length - 1]?.text === "") {
      //点击取消如果最后一条是内容还是loading，说明答案未返回，直接修改成取消
      chatContent[chatContent.length - 1].text = "已取消";
      chatContent[chatContent.length - 1].pending = false;
      setChatContent([...chatContent]);
    } else {
      chatContent[chatContent.length - 1].pending = false;
      setChatContent([...chatContent]);
    }
    props.cancleChat(thread_id);
    stopFetching();
    resetFn(true);
  };
  const setText = (value: string) => {
    chatTextArea?.current?.setTextAreaValue(value);
  };

  const tipClick = (str: string) => {
    markdown.current = str;
    createChat({ chatContent });
  };
  const reAsk = useCallback(
    (value: string, editItem: any) => {
      const index = chatContent.findIndex(
        (item: any) => item.uuid === editItem.uuid
      );
      let newArray = chatContent.slice(0, index);
      markdown.current = value;
      createChat({ chatContent: newArray, editItem });
    },
    [chatContent, createChat]
  );
  const umlReloadSuccess = useCallback(
    (str: string, uuid: string) => {
      const newArray = chatContent.map((item: any) => {
        if (item.uuid === uuid) {
          item.text = str;
        }
        return item;
      });
      setChatContent(newArray);
    },
    [chatContent]
  );

  const reAnswer = useCallback(
    (index: number, uuid: string) => {
      const askItem = chatContent[index - 1];
      let newArray = chatContent.slice(0, index - 1);
      markdown.current = askItem.text;
      createChat({ chatContent: newArray, editItem: askItem, uuid });
    },
    [chatContent, createChat]
  );

  const showRepo = (
    repo_full_name: string,
    branch_name: string,
    type: string,
    file_path: string = ""
  ) => {
    repoCodePreview?.current &&
      repoCodePreview?.current.getTree({
        repo_full_name,
        branch_name,
        type,
        file_path,
      });
  };
  const codePreviewClose = () => {
    setSplitterSize(["100%", 0]);
    isShowRepo.current = false;
    props.repoClick(isShowRepo.current);
  };
  const onResize = (size: number[]) => {
    setSplitterSize(size);
  };
  const handleClickRepo = (
    data: {
      type: string;
      repo_full_name: string;
      branch_name: string;
      url?: string;
    },
    action?: "quote" | "preview",
    fileInfo?: {
      openai_file_id?: string;
      original_filename?: string;
      startLine?: number;
      endLine?: number;
    }
  ) => {
    if (action === "quote") {
      if (fileInfo) {
        chatTextArea?.current?.initFileData(fileInfo);
      } else {
        chatTextArea?.current?.initRepoData(data);
      }
    } else if (action === "preview") {
      if (
        !isShowRepo.current ||
        data.repo_full_name !== showRepoName.repo_full_name
      ) {
        isShowRepo.current = true;
        if (splitterSizeRef.current.includes(0)) {
          setSplitterSize(["50%", "50%"]);
        }
        setShowRepoName({ ...data });
        showRepo(data.repo_full_name || "", data.branch_name || "", data.type);
        props.repoClick(isShowRepo.current);
      }
      if (fileInfo) {
        setTimeout(() => {
          repoCodePreview?.current?.outSelectFile(fileInfo);
        }, 100);
      }
    }
  };
  const onQuote = (data: selectData, askStr?: string) => {
    setQuoteData(data);
    if (askStr) {
      markdown.current = askStr;
      createChat({ chatContent, quoteData: data });
    }
  };
  const chatLine = React.useMemo(() => {
    return (
      <ChatpdfLine
        chatContent={chatContent}
        tipClick={tipClick}
        ref={chatpdfLine}
        reAsk={reAsk}
        key={thread_id}
        umlReloadSuccess={umlReloadSuccess}
        reAnswer={reAnswer}
        stop={stop}
        handleClickRepo={handleClickRepo}
        loading={loading}
      />
    );
  }, [chatContent, stop, loading, thread_id]);

  const handleDragEnter = (e: React.DragEvent) => {
    if (Array.from(e.dataTransfer.types).includes("Files")) {
      if (!dragOver) {
        setDragOver(true);
      }
    }
  };

  const handleDragLeave = (e: React.DragEvent) => {
    // 检查是否实际有文件拖离
    const { target, relatedTarget } = e;
    if (!relatedTarget || !(relatedTarget as HTMLElement).closest("#chatpdf")) {
      setDragOver(false);
    }
  };
  const checkLogin = () => {
    const token = localStorage.getItem("token");
    if (!userInfo.login || !token) {
      changeCommonData({ showLogin: true });
      return false;
    }
    return true;
  };
  return (
    <div className={styles.chatpdfBox}>
      <Splitter className={styles.chatSplitter} onResize={onResize}>
        <Splitter.Panel size={splitterSize[0]} min="40%" max="60%">
          <div
            className={styles.chatPanel}
            ref={chatPanel}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
          >
            {chatpdfTips ? (
              <ChatCreatContent
                handleClick={(tip) => {
                  setChatpdfTips(false);
                  setText(tip);
                  markdown.current = tip;
                }}
              />
            ) : (
              chatLine
            )}
            {/* 底部对话输入模块 */}
            <div className={styles.chatBottom}>
              <ChatTextArea
                ref={chatTextArea}
                handleInputChange={handleInputChange}
                cancleFn={cancleFn}
                send={() => {
                  if (!checkLogin()) {
                    return;
                  }
                  createChat({ chatContent });
                }}
                stop={stop}
                quoteData={quoteData}
                clearQuote={() => setQuoteData(undefined)}
                handleUploadChange={(file) => {
                  uploadFile.current = file;
                }}
              ></ChatTextArea>
              <BottomLayer
                className={styles.tips}
                suffix={"人工智能生成内容仅供参考，使用前请校验内容的正确性。"}
              />
            </div>
            <div
              className={styles.dragover}
              style={{ display: dragOver ? "block" : "none" }}
            >
              <UpLoad
                dragger={true}
                disabled={stop && dragOver}
                onUpLoadDrop={() => {
                  setDragOver(false);
                }}
                url={`/api/v1/chat/file`}
                onUpLoadChange={(file) => {
                  chatTextArea.current?.uploadFile(file);
                }}
              ></UpLoad>
            </div>
          </div>
        </Splitter.Panel>
        <Splitter.Panel
          size={splitterSize[1]}
          resizable={splitterSize[1] !== 0}
        >
          <RepoCodePreview
            ref={repoCodePreview}
            repoData={showRepoName}
            close={codePreviewClose}
            onQuote={onQuote}
            isAnswer={stop}
            key={thread_id}
          ></RepoCodePreview>
        </Splitter.Panel>
      </Splitter>
      {contextHolder}
    </div>
  );
};

export default forwardRef(ChatpdfBox);
